module.exports = __webpack_public_path__ + "static/media/selectArea.4fc79ac3.svg";